import type { StateCreator } from 'zustand'

interface State {
  userIdToSendGift: null | number
  modalGiftOpen: {
    visible: boolean
    chatId?: number
    giftId?: number
  }
}

interface Actions {
  openModalGift(userId?: number, chatId?: number): void
  closeModalGift(): void
}

export type ModalLiveSlice = State & Actions

export const modalsLiveStore: StateCreator<
  ModalLiveSlice,
  [],
  [],
  ModalLiveSlice
> = (set) => ({
  userIdToSendGift: null,
  modalGiftOpen: {
    visible: false,
  },
  openModalGift: (userId, chatId) => {
    set({
      userIdToSendGift: userId,
      modalGiftOpen: { visible: true, chatId },
    })
  },
  closeModalGift: () => {
    set({
      userIdToSendGift: null,
      modalGiftOpen: {
        visible: false,
      },
    })
  },
})
